/***
*
*   useUserEmails hook
*   fetch, format and return the users
*
**********/

import { useState, useEffect } from 'react';
import { useAPI } from 'components/lib';

export function useUserEmails() {

    const [state, setState] = useState({ data: null, loading: false });
    const users = useAPI('/api/user');
    const accounts = useAPI('/api/account');

    useEffect(() => {

        setState({ loading: true });

        const user = users.data?.users?.map(userData => ({
            value: userData._id, label: userData.email
        })) || [];

        const account = accounts.data?.map(accountData => ({
            value: accountData.user_id, label: accountData.owner_email
        })) || [];

        setState({ data: { list: user, accounts: account }, loading: false });

    }, [users, accounts]);

    return state;

}